import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { BehaviorSubject, Observable, catchError, of, tap, timeout } from 'rxjs';

export const EXACT_STATUS_PAGE_URL = 'https://status.exact.com/';

export enum ExactOnlineStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  OFFLINE = 'offline',
  ONLINE = 'online',
  UNAVAILABLE = 'unavailable'
};

export class ExactUser {
  UserName: string;
  DivisionCustomerName: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExactService extends BaseService<unknown> {

  private _exactOnlineStatus = new BehaviorSubject<ExactOnlineStatus>(ExactOnlineStatus.IDLE);
  public exactOnlineStatus$: Observable<ExactOnlineStatus> = this._exactOnlineStatus.asObservable();

  private _me = new BehaviorSubject<ExactUser>(null);
  public me$: Observable<ExactUser> = this._me.asObservable();

  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/exact'
  }

  public checkExactOnlineStatus = (): Observable<Response<any>> => {
    this._exactOnlineStatus.next(ExactOnlineStatus.LOADING);

    return this._http.get<Response<any>>(`${this.getUrl(this.path)}/status`)
      .pipe(
        timeout(20000),
        tap(({ data }) => {
          this._exactOnlineStatus.next(data?.is_authenticated ? ExactOnlineStatus.ONLINE : ExactOnlineStatus.OFFLINE);

          if (data?.me) {
            this._me.next(data.me);
          }
        }),
        catchError(() => {
          this._exactOnlineStatus.next(ExactOnlineStatus.UNAVAILABLE);
          return of({ data: { is_authenticated: false, me: null } } as Response<any>);
        })
      );
  }

  public login = (): void => {
    window.location.href = `${this.getUrl()}exact/auth/authorize?redirect_url=${window.location.origin}`;
  }
}
